// extracted by mini-css-extract-plugin
export default {"MainBlock":"OptionHeader_MainBlock__1jp-3","OptionHeaderTitle":"OptionHeader_OptionHeaderTitle__sMGs8"};